const getSuggestionHtmlId = (prefix, id) => `${prefix}-${id}`

export default getSuggestionHtmlId